import React from "react";
import PropTypes from "prop-types";
import LocalNavSoftLink from "../LocalNavSoftLink";

export default function BrandingAndSystemSection({ hasSuperAdmin, hasExperianAdmin }) {
    return (
        <>
            <LocalNavSoftLink removeLi id="edit-logo" destination="/admin/image-control" text="Image Control" />
            <LocalNavSoftLink
                removeLi
                id="distribution-list"
                destination="/admin/distribution-list"
                text="Distribution List"
            />
            {hasSuperAdmin && (
                <LocalNavSoftLink
                    removeLi
                    id="security-actions"
                    destination="/admin/security-actions"
                    text="Security Actions"
                />
            )}
            {(hasSuperAdmin || hasExperianAdmin) && (
                <LocalNavSoftLink removeLi id="log-messages" destination="/admin/log-messages" text="Log Messages" />
            )}
            {hasSuperAdmin && (
                <LocalNavSoftLink removeLi id="cached-data" destination="/admin/cached-data" text="Cached Data" />
            )}
            {hasSuperAdmin && (
                <LocalNavSoftLink
                    removeLi
                    id="canned-report"
                    destination="/admin/canned-report"
                    text="Canned Report Management"
                />
            )}
            {hasSuperAdmin && (
                <LocalNavSoftLink
                    removeLi
                    id="active-mq"
                    destination="/admin/snowflake-instances"
                    text="Snowflake Instances"
                />
            )}
            {hasSuperAdmin && (
                <LocalNavSoftLink
                    removeLi
                    id="deployment-destinations"
                    destination="/admin/deployment-destinations"
                    text="Deployment Destinations"
                />
            )}
        </>
    );
}

// Mark safe for LocalNavMenu structural expansion (must remain hook-free)
BrandingAndSystemSection.__localNavSection = true;

BrandingAndSystemSection.propTypes = {
    hasSuperAdmin: PropTypes.bool.isRequired,
    hasExperianAdmin: PropTypes.bool.isRequired,
};
